import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterAssignedUsers = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterAssignedUsers'),
);
